/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { BaseSettingsService } from './base-settings.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseURL: string;

  /**
   * Initialize this class
   */
  constructor(private baseSettings: BaseSettingsService, private http: HttpClient) {
    this.baseURL = baseSettings.baseAPIsURL +'customers/';
  }

  /**
   * Login
   */
  login(params: any) {
    let url = this.baseURL + 'login';
    return this.http.post(url, params).map(res => res);
  }
}
